import React, { useEffect, useMemo, Dispatch, SetStateAction } from 'react';
import ReactDOM from 'react-dom';
import { IProduct, IProductEdp } from './IProduct';

export interface PdpAdvanceOrderProps {
    SelectedEdpItem: IProductEdp;
    isAutoDeliveryEnabled: boolean;
    ProductData: IProduct;
    //setIsPropertyTrue: Dispatch<SetStateAction<boolean>>;
    getEasyPayArticle: () => {};
}
const domNode = document.getElementById('divEasyPayment');
if (domNode) {
    domNode.innerHTML = '';
}

const PdpEasyPayButton = ({
    SelectedEdpItem,
    ProductData,
    getEasyPayArticle,
    isAutoDeliveryEnabled,
}: PdpAdvanceOrderProps) => {
    const {
        Name,
        ItemNo,
        DefaultEdp,
        IsSoldOut,
        DeliveryOptions,
        IsPriceRange,
        WasPriceRange,
        ProductReviewCount,
        ProductReviewRating,
        Styles = [],
        Sizes = [],
        AvailableSwatches,
        NoReturnsMessage,
        Edps,
        Brand,
        BrandDimensionId,
        BadgeImagePath,
        ProductTypePath,
    } = ProductData;
    const isEasyPay = useMemo(() => {
        if (!SelectedEdpItem || !SelectedEdpItem?.EasyPaymentPrice) {
            return false;
        }
        return true;
    }, [SelectedEdpItem]);

    const productName = useMemo(() => {
        if (isAutoDeliveryEnabled) {
            return DeliveryOptions.find((item) => item.EdpNo == SelectedEdpItem.EdpNo).DisplayName;
        } else {
            return Name;
        }
    }, [DeliveryOptions, SelectedEdpItem, Name, isAutoDeliveryEnabled]);

    const easyPay = useMemo(() => {
        {
            if (!SelectedEdpItem || !SelectedEdpItem?.EasyPaymentPrice) {
                return false;
            } else {
                return SelectedEdpItem.EasyPaymentPrice;
            }
        }
    }, [DeliveryOptions, SelectedEdpItem, Name, isAutoDeliveryEnabled]);

    if (!domNode) {
        return null;
    }

    return ReactDOM.createPortal(
        <>
            {(isEasyPay || NoReturnsMessage) && (
                <>
                    <div className="pdp-description__easy-pay">
                        {isEasyPay && (
                            <div className="pdp-description__easy-pay__easy-pay-text">
                                <span>or </span>
                                <span className="pdp-description__easy-pay__easy-pay-count"> {easyPay} </span>
                                <span className="pdp-description__easy-pay__with">
                                    with{' '}
                                    <span>
                                        <button
                                            type="button"
                                            className="pdp-description__easy-pay__button"
                                            onClick={() => getEasyPayArticle()}
                                        >
                                            EASY PAY&reg;
                                        </button>
                                    </span>
                                </span>
                            </div>
                        )}
                        {NoReturnsMessage && (
                            <div id="lblFinalSale" className="pdp-description__easy-pay__no-returns">
                                {NoReturnsMessage}
                            </div>
                        )}
                    </div>
                    <div className="horizontal-divider pdp-description__divider"></div>
                </>
            )}
        </>,
        domNode,
    );
};

export default PdpEasyPayButton;
